module.exports = __webpack_public_path__ + "img/sipur_yes.53fcd432.png";